/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { PageHeader, Tabs, Divider, Collapse, Descriptions, Typography, Result, Tooltip, Spin } from 'antd';
import { red, volcano, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey, orange, } from '@ant-design/colors';

import { actNetRequestClear, getNetRequestStatus, netRequestThunk } from '../../../util/netReqRD';
import { 
    groupListRegistrationData, ACT_NET_REGISTRATION_GROUP_LIST, dataGroupListRegistration, groupListRegistrationDataSuccessHd,
} from './registrationRD';
import {getLoginUserInfo} from '../../login/loginRD'

import { 
    HoCard, HoBreadcrumb, HoRefreshButton,
} from '../../../util/hoComponent';
import { 
    HoTable, hoTableInitPaginationInfo, 
    hoTableColumn, hoTableColumnDate, hoTableColumnAction, hoTableColumnTag, hoTableColumnTagButton 
} from '../../../util/tableComponent';


class RegistrationCT extends Component{
    constructor(props){
        super(props);

        /********************************** 主页面 ***********************************/
        // 主页面回调
        this.tblColOnChange = this.tblColOnChange.bind(this);
        this.tblRowOnClick = this.tblRowOnClick.bind(this);
        this.tblRowDetailOnClick = this.tblRowDetailOnClick.bind(this);
        
        // 主页面按钮
        this.mainRefreshOnClick = this.mainRefreshOnClick.bind(this);

        this.renderExtra = this.renderExtra.bind(this);

        // 主页面
        this.mkBreadcrumb = this.mkBreadcrumb.bind(this);
        this.mkHeaderInfo = this.mkHeaderInfo.bind(this);
        this.mkTable = this.mkTable.bind(this);
      
        const columns = [
            hoTableColumnTag('事件', 'action', 
                (text, record) => {
                    let tags = [];
                    switch(record.action){
                        case 'register':
                            tags.push({color: blue[3], tag:'用户注册'});
                            break;
                        case 'unregister':
                            tags.push({color: grey[3], tag:'用户注销'});
                            break;
                        case 'forbidden':
                            tags.push({color: red[3], tag:'注册失败'});
                            break;
                        case 'refresh':
                            tags.push({color: blue[3], tag:'刷新注册'});
                            break;
                        case 'expire':
                            tags.push({color: red[3], tag:'超时注销'});
                            break;
                        default:
                            break;
                    }
                    
                    return hoTableColumnTagButton(tags, record);
                }, 
            '8%'),
            hoTableColumn('号码', 'sipNum', 'str', false, true, '8%'),
            hoTableColumnDate('触发时间', 'createTime', false, '15%'),
            hoTableColumn('额外参数', 'str', 'extra', false, false, '35%', {
                render: (text, record) => { return this.renderExtra(record);}
            }),
            hoTableColumnAction('操作', 'operation', [
                {title: '详情', onClick: this.tblRowDetailOnClick},
            ], '12%'),
        ];

        this.state = {
            columns: columns,
            paginationInfo: hoTableInitPaginationInfo(),
        }
    }

    renderExtra(record){

        switch(record.action){
            case 'register': 
            case 'unregister': 
            case 'forbidden': 
            case 'refresh': 
            case 'expire':
                const info = record.extra;
                return <Descriptions size="small" column={1}>
                    <Descriptions.Item label="超时时间">{info.expire}</Descriptions.Item>
                    <Descriptions.Item label="IP地址">{info.remoteIp}</Descriptions.Item>
                    <Descriptions.Item label="端口">{info.remotePort}</Descriptions.Item>
                    <Descriptions.Item label="user-agent">{info.userAgent}</Descriptions.Item>
                    <Descriptions.Item label="contact">{info.contact}</Descriptions.Item>
                </Descriptions>;
            default: 
                return undefined;
        }
    }

    // 过滤、排序、分页发生变化
    tblColOnChange(paginationInfo){
        dataGroupListRegistration(this.props, paginationInfo, groupListRegistrationDataSuccessHd);
        this.setState({
            paginationInfo: paginationInfo,
        });
    }

    // 单行被点击
    tblRowOnClick(e, record){
        this.tblRowDetailOnClick(e, record);
    }

    // '详情'按钮被点击
    tblRowDetailOnClick(e, record){
        e.stopPropagation();
        window.goToMenu('devops/analysis/registration', `detail/${record.sipNum}`)
    }

    // '刷新'按钮被点击
    mainRefreshOnClick(){
        const { paginationInfo } = this.state;
        dataGroupListRegistration(this.props, paginationInfo, groupListRegistrationDataSuccessHd);
    }

    // 面包屑
    mkBreadcrumb(){
        return <HoBreadcrumb
            items={[{title: "数据分析", url: "devops/analysis"}, {title: "注册"}]}
        />
    }

    mkHeaderInfo(){
        const buttons = (<div>
            <HoRefreshButton onClick={this.mainRefreshOnClick}/>
        </div>);
        return {title: <span>注册</span>, buttons: buttons}; 
    }

    mkTable(){
        let { columns } = this.state;
        const { data, getStatus } = this.props;
        const { records, paginationInfo } = data || {};
        const { total } = (paginationInfo && paginationInfo.pagination) || 0;

        // console.log("mkTable", data);

        return (<HoTable
            columns={columns}
            data={records}
            rowKey={'uuid'}
            loading={getStatus === 1}
            onColumnChange={this.tblColOnChange}
            onRowDoubleClick={this.tblRowOnClick}
            total={total}
        />);
    }

    // clear handle
    componentWillUnmount(){
        let {dispatch} = this.props;
        dispatch(actNetRequestClear(ACT_NET_REGISTRATION_GROUP_LIST));
    }

    componentDidMount(){
        const { paginationInfo } = this.state;
        dataGroupListRegistration(this.props, paginationInfo, groupListRegistrationDataSuccessHd);
    }

    render(){
        const {reqUserInfo} = this.props;
        // 主页面
        const breadcrumbComponent = this.mkBreadcrumb();
        const {title, buttons} = this.mkHeaderInfo();
        const tableComponent = this.mkTable();

        return (<div>
            {breadcrumbComponent}
            <HoCard title={title} buttons={buttons} >
                {tableComponent}
            </HoCard>
        </div>);
    }
}

const mapState = (state) => ({
    reqUserInfo: getLoginUserInfo(state), 
    getStatus: getNetRequestStatus(state, ACT_NET_REGISTRATION_GROUP_LIST), 
    data: groupListRegistrationData(state),
});


export default connect(
    mapState, 
    null
)(RegistrationCT);

